import { render, staticRenderFns } from "./CollapseExtrafield.vue?vue&type=template&id=11cfad20&scoped=true&lang=pug&"
import script from "./CollapseExtrafield.vue?vue&type=script&lang=js&"
export * from "./CollapseExtrafield.vue?vue&type=script&lang=js&"
import style0 from "./CollapseExtrafield.vue?vue&type=style&index=0&id=11cfad20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cfad20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VBtn,VCol,VDatePicker,VDialog,VForm,VRow,VSelect,VTextField,VTextarea,VTimePicker})
